import React, { useEffect, useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ScenarioCard from '../mainlayout/body/ScenarioCard';
import * as SearchAPI from '../../services/SearchServices';
import UserCard from './UserCard';
import SearchContext from '../../context/SearchContext';
import styles from './styles/Search.module.css';
import Loading from '../../components/loading/Loading';

// Should probably utilize the newish SearchBar instead.
function Search() {
    const { searchQuery, setSearchQuery, searchType, setSearchType, searchResults, setSearchResults } = useContext(SearchContext);
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const query = params.get('query');
        const type = params.get('type') || 'scenario';
        const isTag = params.get('tag') === 'true';

        if (!query) {
            setError('Query parameter is missing');
            setLoading(false);
            return;
        }

        if (!type) {
            setError('Type parameter is missing');
            setLoading(false);
            return;
        }

        setSearchQuery(query);
        setSearchType(type);
        setLoading(true);
        setError('');

        SearchAPI.search(query, type, isTag)
            .then(data => {
                setSearchResults(data.results);
                setLoading(false);
            })
            .catch(() => {
                setError('Error fetching search results');
                setLoading(false);
            });
    }, [location.search, setSearchQuery, setSearchType, setSearchResults]);

    if (loading) {
        return <div className={styles.centeredContainer}><Loading/></div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    if (!searchResults || searchResults.length === 0) {
        return <div>No results found.</div>;
    }


    return (
        <div className={styles.searchPageContainer}>
            <h1 className={styles.searchPageTitle}>
                Search Results for "<span className={styles.searchQueryTerm}>{searchQuery}</span>"
            </h1>
            {searchResults && searchResults.length > 0 ? (
                <div className={styles.resultsGrid}>
                    {searchType === 'scenario' && searchResults.map(result => (
                        <ScenarioCard key={result._id} scenario={result} searchQuery={searchQuery} />
                    ))}
                    {searchType === 'user' && searchResults.map(result => (
                        <UserCard key={result._id} user={result} />
                    ))}
                </div>
            ) : (
                <div className={styles.noResultsContainer}>
                    <p className={styles.noResultsMessage}>
                        No {searchType} results found for "<span className={styles.searchQueryTerm}>{searchQuery}</span>".
                    </p>
                    <p className={styles.noResultsSuggestion}>
                        Try refining your search or check your spelling.
                    </p>
                </div>
            )}
        </div>
    );
}

export default Search;
